// Generated from the backend PermissionCode OpenAPI enum. Do not edit.
export const permissionCodes = [
  "account.self.manage",
  "admin.access",
  "admins.manage",
  "approval-policies.manage",
  "approval.execution.manage",
  "approvals.decide",
  "approvals.read",
  "audit.read",
  "urgent-notices.read",
  "urgent-notices.publish",
  "urgent-notices.correct",
  "city-reports.read",
  "city-reports.review",
  "destinations.manage",
  "destinations.read",
  "experiences.manage",
  "experiences.read",
  "legal.acceptance.read",
  "legal.manage",
  "notifications.read",
  "profiles.review",
  "public-reviews.moderate",
  "review-sessions.read",
  "roles.manage",
  "partner-contacts.manage",
  "partner-contacts.read",
  "partner-contacts.erase",
  "partner-feedback.review",
  "partner-offering-notes.manage",
  "partner-offering-notes.read",
  "partner-offerings.manage",
  "partner-offerings.read",
  "partner.import",
  "partner.import.operate",
  "partner.evidence.hold.manage",
  "partner-schedules.manage",
  "partner-schedules.read",
  "partner-team.manage",
  "partners.manage",
  "partners.read",
  "support.read",
  "support.manage",
  "suggestions.read",
  "suggestions.manage",
  "sessions.read",
  "sessions.revoke",
  "social-content.review",
  "social-metadata.read",
  "social-reports.review",
  "traveler-feedback.review",
  "user.access",
  "users.access.manage",
  "users.invite",
  "users.read",
  "video-verifications.review"
] as const;
